import {observer} from "mobx-react-lite";
import React, {useContext, useState} from "react";
import {Accordion, Form} from "react-bootstrap";
import {Context} from "../index";
import { XLg } from 'react-bootstrap-icons';
import './filter.css';
import { useNavigate, useLocation } from "react-router-dom";


const Filter = observer(({selectedFolderFilters}) => {
  const {user, product} = useContext(Context)
  const navigate = useNavigate();
  const location = useLocation();

    const [expandedFilters, setExpandedFilters] = useState({}); // показать всё/скрыть
    const toggleExpanded = (filterName) => {
        setExpandedFilters(prev => ({
            ...prev,
            [filterName]: !prev[filterName]
        }));
    };
    
    const handleCheckboxChange = (filterName, optionName) => {
        const selected = product.selectedFilters?.[filterName] || [];
        let updated = [...selected];
        if (updated.includes(optionName)) {
            updated = updated.filter(item => item !== optionName);
        } else {
            updated.push(optionName);
        }
        product.setSelectedFilters({
            ...product.selectedFilters,
            [filterName]: updated
        });
        product.setPage(0);
    };

    const handleRangeChange = (filterName, field, value) => {
    const selected = product.selectedFilters?.[filterName] || {from: '', to: ''};                
        product.setSelectedFilters({
            ...product.selectedFilters,
            [filterName]: {
                ...selected,
                [field]: value
            }
        });      
        product.setPage(0);
    };

 //  <Accordion defaultActiveKey={['0','2','3', '100']} alwaysOpen> // какие блоки открываются по умолчанию в фильтрах

    // mainFilters - фильтры сортировки, promoFilters - фильтры акций
    const mainFilters = product.filters?.filter(f => f.order < 13) || [];
    const promoFilters = product.filters?.filter(f => f.order >= 13) || [];

    const renderFilterBlock = (filters, title) => (
      <Accordion className="mt-3">
        {title && (
          <Accordion.Item eventKey="header">
            <Accordion.Header className={title === "Акции" ? "text-danger no-arrow" : ""} > 
              {title}
            </Accordion.Header>
          </Accordion.Item>
        )}

        {filters.map((filter, idx) => {
          const isExpanded = expandedFilters[filter.name];
          const sortedValues = [...filter.values].sort((a, b) => {
            const aNum = parseFloat(a.name);
            const bNum = parseFloat(b.name);
            const aIsNum = !isNaN(aNum);
            const bIsNum = !isNaN(bNum);
            if (aIsNum && bIsNum) return aNum - bNum;
            if (aIsNum) return -1;
            if (bIsNum) return 1;
            return a.name.localeCompare(b.name);
          });
          const displayValues = isExpanded ? sortedValues : sortedValues.slice(0, 11);
          
          const isSwitchFilter = ["Бесплатный монтаж", "Товары со скидкой"].includes(filter.name);
          const switchFilterValues = {
                "Бесплатный монтаж": "1",
                "Товары со скидкой": "true"
            };
          const isChecked = Array.isArray(product.selectedFilters?.[filter.name]) &&
                product.selectedFilters[filter.name].includes(switchFilterValues[filter.name]);

          return (
            <Accordion.Item eventKey={String(idx)} key={filter.name}>
              <Accordion.Header className={`d-flex justify-content-between align-items-center ${isSwitchFilter ? 'no-toggle' : ''}`} >
                {filter.name}
                {isSwitchFilter && (
                  <Form.Check
                    type="switch"
                    id={`switch-${filter.name}`}
                    className="ms-3"
                    checked={isChecked}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      const updatedFilters = { ...product.selectedFilters };
                      if (checked) {
                         updatedFilters[filter.name] = [switchFilterValues[filter.name]];
                      } else {
                        delete updatedFilters[filter.name];
                      }
                      product.setSelectedFilters(updatedFilters);
                      product.setPage(0);
                    }}
                    onClick={(e) => e.stopPropagation()}
                    label=""
                  />
                )}
              </Accordion.Header>

              {!isSwitchFilter && (
                <Accordion.Body>
                  <Form>
                    {filter.type === "SELECT" && (
                      <div className={`filter-values-wrapper ${isExpanded ? "expanded" : ""}`}>
                        {displayValues.map(value => {
                          const originalName = value.name;
                          const visualLabel = 
                            filter.name === "Тип компрессора"
                              ? originalName.toLowerCase() === "да"
                                ? "Инверторный / Inverter"
                                : originalName.toLowerCase() === "нет"
                                  ? "Роторный / On-Off"
                                  : originalName
                            : filter.name === "Бесплатный монтаж"
                              ? value.name === "1"
                                ? "Да"
                                : value.name === "2"
                                  ? "Нет"
                                  : value.name
                            : filter.name === "Скидка на монтаж, %" && originalName === "0"
                              ? "Без скидки"
                              : originalName;

                          return (
                            <Form.Check
                              key={originalName}
                              type="checkbox"
                              label={visualLabel}
                              checked={(product.selectedFilters?.[filter.name] || []).includes(originalName)}
                              onChange={() => handleCheckboxChange(filter.name, originalName)}
                            />
                          );
                        })}
                        {filter.values.length > 11 && (
                          <button
                            type="button"
                            className="small text-decoration-underline d-block mt-2 btn p-0"
                            onClick={() => toggleExpanded(filter.name)}
                          >
                            {isExpanded ? "Скрыть" : "Показать все"}
                          </button>
                        )}
                      </div>
                    )}

                    {(filter.type === "PRICE" || filter.type === "RANGE") && (
                      <div className="d-flex flex-row align-items-center">
                        <Form.Control
                          size="sm"
                          type="number"
                          placeholder={filter.from}
                          value={product.selectedFilters?.[filter.name]?.from || ""}
                          onChange={(e) => handleRangeChange(filter.name, "from", e.target.value)}
                          style={{ WebkitAppearance: "none", MozAppearance: "textfield" }}
                        />
                        <span className="px-3">—</span>
                        <Form.Control
                          size="sm"
                          type="number"
                          placeholder={filter.to}
                          value={product.selectedFilters?.[filter.name]?.to || ""}
                          onChange={(e) => handleRangeChange(filter.name, "to", e.target.value)}
                          style={{ WebkitAppearance: "none", MozAppearance: "textfield" }}
                        />
                      </div>
                    )}
                  </Form>
                </Accordion.Body>
              )}
            </Accordion.Item>
          );
        })}
      </Accordion>
    );

    return (
        <>
            <Accordion defaultActiveKey={['100']} alwaysOpen>
                <Accordion.Item eventKey="100" className="border-1 rounded-top-4">
                    <Accordion.Body className="px-3">
                        <Form>
                            <div className="d-flex align-items-center">
                                <XLg className="me-2" />
                                <button
                                    type="button"
                                    className="view_all_btn btn p-0"
                                    onClick={() => {
                                        product.setSelectedFilters(null);
                                        product.setPagination({
                                           page: 0,        // если бек возвращает с 0, а у тебя page с 1
                                           pageSize: 20
                                        });
                                    }}
                                >
                                    Сбросить фильтры
                                </button>
                            </div>
                        </Form>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
            {/* Фильтры Акции */}
            {promoFilters.length > 0 && renderFilterBlock(promoFilters, "Акции", true)}

            {/* Основные фильтры */}
            {renderFilterBlock(mainFilters)}


        </>
    );
});

export default Filter;
